import React from 'react';
import { Box, Container, Toolbar, useMediaQuery, useTheme } from '@material-ui/core';
import { isNumber } from 'lodash/fp';
import { Loader } from '../modules/shared';
import { useGetInitInfoQuery } from '../generated/graphql';
import { DebtBanner, FixedBox } from '../ui-kit';
import { useUser } from '../utils/hooks/auth';
import SidebarElement from './SidebarElement';
import { MainElement } from './style';
import Navbar from './Navbar';

const PrivateRouteLayout: React.FC = ({ children }) => {
    const theme = useTheme();
    const [isDrawerOpen, setOpenDrawer] = React.useState(false);
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const { user: { currentVenueId } } = useUser();
    const { data, loading } = useGetInitInfoQuery();
    const handleDrawerClose = () => setOpenDrawer(false);
    const handleDrawerOpen = () => setOpenDrawer(true);

    if (loading) {
        return (
            <Box display='flex' justifyContent='center' alignItems='center' flexDirection='column' flexGrow={1} height="100vh">
                <Loader />
            </Box>
        );
    }
    if (data && !loading) {
        const shouldShowSidebar = data.employeePermissions.warehouse.length > 0;
        const { venues } = data;
        const currentVenue = venues.find(({ id }) => id === currentVenueId);
        const hasDebt = isNumber(currentVenue?.debt);

        return (
            <>
                <Navbar
                    shouldShowSidebar={shouldShowSidebar}
                    setOpenDrawer={setOpenDrawer}
                    isDrawerOpen={isDrawerOpen}
                />
                {shouldShowSidebar
                    ? (
                        <SidebarElement
                            isDrawerOpen={isDrawerOpen}
                            handleDrawerClose={handleDrawerClose}
                            handleDrawerOpen={handleDrawerOpen}
                        />
                    ): null}
                <MainElement padding={isDesktop && shouldShowSidebar}>
                    <Container disableGutters maxWidth={false}>
                        {hasDebt ? (
                            <Toolbar disableGutters>
                                <FixedBox>
                                    { /* @ts-ignore */ }
                                    <DebtBanner debt={currentVenue.debt} dueDate={currentVenue.dueDate} />
                                </FixedBox>
                            </Toolbar>
                        ) : null}
                        <Box display='flex' flexDirection='column' flexGrow={1} height="100%">
                            {children}
                        </Box>
                    </Container>
                </MainElement>
            </>
        );
    }

    return null;
};

export default PrivateRouteLayout;
